<template>
    <div class="wrap">
        <div class="title">
            <el-breadcrumb >
                <el-breadcrumb-item>优客码</el-breadcrumb-item>
                <el-breadcrumb-item>活动发布</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main">
            <el-card>
                <el-row :gutter="10" class="index-head">
                    <el-col :span="4">
                        <el-input placeholder="活动名称" v-model="activename" clearable @clear="handleButton(2)"> </el-input>
                    </el-col>
                    <!--   <el-col :span="4">
        <el-select v-model="opt_id"
                   placeholder="发起人">
          <el-option v-for="item in opt_idlist"
                     :key="item.users_mains_id"
                     :label="item.real_names"
                     :value="item.users_mains_id">
          </el-option>
        </el-select>
      </el-col> -->
                    <el-col :span="4">
                        <el-select v-model="statusValue" placeholder="状态">
                            <el-option v-for="item in GLOBALState.erw_options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="handleButton(2)"> 搜 索 </el-button>
                        <el-button @click="handleButton(3)">重 置</el-button>
                        <el-button type="primary" @click="handleButton(1)"> 发起活动 </el-button>
                    </el-col>
                </el-row>
                <div class="table-content">
                    <el-table :data="list" border v-loading="listLoading">
                        <el-table-column label="id" prop="id"></el-table-column>
                        <el-table-column label="活动名称" prop="name"></el-table-column>
                        <!--    <el-table-column label="关联店铺"
                         prop="shop_name"></el-table-column> -->
                        <el-table-column label="发起人" prop="opt_name"></el-table-column>
                        <el-table-column label="开始时间" prop="begin_time"></el-table-column>
                        <el-table-column label="结束时间" prop="end_time"></el-table-column>
                        <el-table-column label="状态" prop="status">
                            <template slot-scope="scope">
                                {{ scope.row.status == 0 ? "未开始" : scope.row.status == 1 ? "进行中" : scope.row.status == 2 ? "已结束" : "已关闭" }}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" @click="handleButton(4, scope.row)">查看二维码</el-button>
                                <el-button type="text" @click="handleButton(6, scope.row.id)">效果统计</el-button>
                                <el-button type="text" @click="handleButton(5, scope.row.id)">授权名单管理</el-button>
                                <!-- <el-button type='text' v-if="scope.row.status==0"
                       @click="handleButton(6,scope.row)">编辑</el-button> -->
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 分页 -->
                <pagination v-if="list.length > 0" :total="total" :pageNum="pageNum" :pageSize="pageSize" @pageChange="pageChange" />
                <div v-if="publicVisible">
                    <publicactive @closeModel="initModel(1)" :method="getactivelist_" :rowlist="rowlist"></publicactive>
                </div>
                <div v-if="erweimaVisible">
                    <erweimacactive @closeModel="initModel(2)" :logosrc="logosrc"></erweimacactive>
                </div>
                <div v-if="authorVisuble">
                    <author @closeModel="initModel(3)" :dateils_id="dateils_id"></author>
                </div>
                <div v-if="tipNumber">
                    <tipNumbers @closeModel="initModel(4)"></tipNumbers>
                </div>
                <div v-if="authordata">
                    <chartdata @closeModel="initModel(6)" :title="datatitle"></chartdata>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import tipNumbers from "./common/tipNumbers.vue";
import { toolNumner } from "@/api/operate/index";
import { getactivelist, getactiveuser } from "@/api/erweima/index";
import pagination from "@/components/pagination/index.vue";
import publicactive from "./common/publicactive.vue";
import erweimacactive from "./common/erwImg.vue";
import author from "./common/author.vue";
import chartdata from "./common/datachart.vue";
export default {
    props: {},
    data() {
        return {
            publicVisible: false,
            erweimaVisible: false,
            activename: "",
            opt_id: "",
            opt_idlist: [],
            statusValue: "",
            list: [],
            pageSize: 5,
            pageNum: 1,
            total: 0,
            listLoading: false,
            logosrc: "",
            rowlist: {},
            authorVisuble: false,
            tipNumber: false,
            authordata: false,
            dateils_id: "",
            datatitle: "",
        };
    },
    computed: {
        ...mapGetters(["getToken", "getAppVerify"]),
    },
    mounted() {
        this.getactivelist_();
        this.getactiveuser_();
    },
    methods: {
        initModel(num) {
            if (num == 1) {
                this.publicVisible = false;
            } else if (num == 4) {
                this.tipNumber = false;
            } else if (num == 2) {
                this.erweimaVisible = false;
            } else if (num == 3) {
                this.authorVisuble = false;
            } else if (num == 6) {
                this.authordata = false;
            }
        },
        handleButton(key, row) {
            switch (key) {
                case 1:
                    if (this.getAppVerify.length > 0) {
                        let f = false;
                        this.getAppVerify.forEach((item) => {
                            if (item.code == "QRCODE") {
                                if (item.is_free != 1 && item.merchant_status != 1) {
                                    console.log(item);
                                    f = true;
                                    this.$message.warning("请先前往 商品管理->营销玩法 购买此应用！");
                                }
                            }
                        });
                        if (f) {
                            return;
                        }
                    }
                    this.toolNumner_();
                    //this.publicVisible = true
                    this.rowlist = {};
                    break;
                case 2:
                    this.getactivelist_();
                    break;
                case 3:
                    this.activename = "";
                    this.publicename = "";
                    this.statusValue = "";
                    this.pageNum = 0;
                    this.getactivelist_();
                    break;
                case 4:
                    /* this.logosrc ='http://114.113.144.175:8122/ShopProductList?users_mains_id=1&opt=485id&actid=2 ' */
                    this.logosrc = row.url;
                    this.erweimaVisible = true;
                    break;
                case 5:
                    this.authorVisuble = true;
                    this.dateils_id = row;
                    this.$setSessionStorage("rebate_id", row);
                    break;
                case 6:
                    this.authordata = true;
                    this.dateils_id = row;
                    console.log(this.dateils_id, "----this.dateils_id");
                    this.datatitle = "效果统计";
                    this.$setSessionStorage("rebate_id", row);
                    break;

                default:
                    break;
            }
        },
        pageChange(page) {
            this.pageSize = page._pageSize;
            this.pageNum = page._currentPage;
            this.getactivelist_();
        },
        getactivelist_() {
            this.listLoading = true;
            let par = {
                token: this.$getSessionStorage("token"),
                offset: this.pageNum,
                limit: this.pageSize,
                name: this.activename,
                status: this.status,
                opt_id: this.$getSessionStorage("userid"),
            };

            getactivelist(par)
                .then((res) => {
                    this.listLoading = false;
                    if (res.code == 1) {
                        this.list = res.data.list;
                        this.total = parseInt(res.data.count);
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        getactiveuser_() {
            let par = {
                token: this.$getSessionStorage("token"),
            };
            getactiveuser(par)
                .then((res) => {
                    if (res.code == 1) {
                        this.opt_idlist = res.data.list;
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
        toolNumner_() {
            let par = {
                token: this.$getSessionStorage("token"),
            };
            toolNumner(par)
                .then((res) => {
                    if (res.code == 1) {
                        if (res.data.number > 0) {
                            this.publicVisible = true;
                        } else {
                            this.tipNumber = true;
                        }
                    } else {
                        this.$message.error({ message: res.msg });
                    }
                })
                .catch((err) => {});
        },
    },
    components: {
        publicactive,
        pagination,
        erweimacactive,
        author,
        tipNumbers,
        chartdata,
    },
};
</script>

<style scoped lang="scss">
.index-head {
    width: 100%;
    padding: 16px 0;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.7);
}
.title {
    box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
    width: 100%;
    background: #fff;
    font-size: 20px;
    color: #000000;
    width: 100%;
    padding: 15px 32px;
}
.main {
    min-width: 1200px;
    margin: 20px;
    .el-card {
        min-height: 780px;
    }
}
</style>
